import script from "./ServiceStandards.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceStandards.vue?vue&type=script&setup=true&lang=js"

import "./ServiceStandards.vue?vue&type=style&index=0&id=f4edaef4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4edaef4"]])

export default __exports__